import RangeSlider from './RangeSlider'
export default RangeSlider
